import { render, staticRenderFns } from "./WorkstationLocationPage.vue?vue&type=template&id=a315adc8"
import script from "./WorkstationLocationPage.vue?vue&type=script&lang=js"
export * from "./WorkstationLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports